<template>
    <div v-if="!data.offer.is_paid_active" class="bottom">
        <div class="left_side">
            <div v-if="data.offer.koncept == 0" :class="(data.offer.send_status == 1 ? 'clicked' : '') +
                ' button_with_without_text vue_show_tooltip'
                " @click="changeSendStatus" data-click="no">
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"
                    data-click="no">
                    <path
                        d="M2.69997 2.15999L6.94497 0.744986C8.84997 0.109986 9.88497 1.14999 9.25497 3.05499L7.83997 7.29999C6.88997 10.155 5.32997 10.155 4.37997 7.29999L3.95997 6.03999L2.69997 5.61999C-0.155034 4.66999 -0.155034 3.11499 2.69997 2.15999Z"
                        stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <span v-if="data.offer.send_status == 1" data-click="no">{{ $t('offer.send_mark_unsent') }}</span>
                <span v-else data-click="no">{{ $t('offer.send_mark_sent') }}</span>
                <tool-tip class="vue_tooltip hide" side="l" :text="data.offer.send_status == 0
                        ? $t('offer.send_tooltip_sent')
                        : $t('offer.send_tooltip_unsent')
                    " />
            </div>
            <div class="button_with_without_text vue_show_tooltip" v-if="data.offer.koncept == 0" @click="copyUrlOffer"
                data-click="no">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"
                    data-click="no">
                    <path
                        d="M8.74417 10.2083H9.625C11.3867 10.2083 12.8333 8.76751 12.8333 7.00001C12.8333 5.23834 11.3925 3.79167 9.625 3.79167H8.74417"
                        stroke-linecap="round" stroke-linejoin="round" />
                    <path
                        d="M5.25 3.79167H4.375C2.6075 3.79167 1.16666 5.23251 1.16666 7.00001C1.16666 8.76167 2.6075 10.2083 4.375 10.2083H5.25"
                        stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M4.66666 7H9.33333" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <span data-click="no">{{ $t('offer.copy_url') }}</span>
                <tool-tip class="vue_tooltip hide" side="l" :text="$t('offer.copy_url_tooltip')" />
            </div>
            <a class="button_with_without_text vue_show_tooltip" :href="'/' +
                data.offer.uuid +
                '/' +
                (data.offer.mojafirma ? data.offer.mojafirma.slug : data.slug) +
                '/' +
                data.offer.id
                " target="_blank" data-click="no" id="v-step-3">
                <svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg"
                    data-click="no">
                    <path d="M5.95833 5.54164L9.71666 1.78331" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M10.0834 3.61667V1.41667H7.88337" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                        d="M5.04167 1.41667H4.12501C1.83334 1.41667 0.916672 2.33334 0.916672 4.62501V7.37501C0.916672 9.66667 1.83334 10.5833 4.12501 10.5833H6.87501C9.16667 10.5833 10.0833 9.66667 10.0833 7.37501V6.45834"
                        stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <span data-click="no">{{ $t('offer.open_offer') }}</span>
                <tool-tip class="vue_tooltip hide" side="l" :text="$t('offer.open_offer_tooltip')" />
            </a>
            <!-- SHOWUP ONLY IN KONCEPT STATE -->
            <a class="button_with_without_text vue_show_tooltip" v-if="data.offer.koncept != 0" @click="editOffer"
                data-click="no">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"
                    data-click="no">
                    <path d="M5.5 1H4.5C2 1 1 2 1 4.5V7.5C1 10 2 11 4.5 11H7.5C10 11 11 10 11 7.5V6.5"
                        stroke-linecap="round" stroke-linejoin="round" />
                    <path
                        d="M8.02 1.50999L4.08 5.44999C3.93 5.59999 3.78 5.89499 3.75 6.10999L3.535 7.61499C3.455 8.15999 3.84 8.53999 4.385 8.46499L5.89 8.24999C6.1 8.21999 6.395 8.06999 6.55 7.91999L10.49 3.97999C11.17 3.29999 11.49 2.50999 10.49 1.50999C9.49 0.509989 8.7 0.829989 8.02 1.50999Z"
                        stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M7.45499 2.07498C7.78999 3.26998 8.72499 4.20498 9.92499 4.54498" stroke-miterlimit="10"
                        stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <span data-click="no">{{ $t('offer.edit_offer') }}</span>
                <tool-tip class="vue_tooltip hide" side="l" :text="$t('offer.edit_offer_tooltip')" />
            </a>
            <a class="button_with_without_text vue_show_tooltip disabled" v-if="data.offer.koncept != 0"
                data-click="no">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"
                    data-click="no">
                    <path d="M4.5 5.5V8.5L5.5 7.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M4.5 8.5L3.5 7.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M11 5V7.5C11 10 10 11 7.5 11H4.5C2 11 1 10 1 7.5V4.5C1 2 2 1 4.5 1H7"
                        stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M11 5H9C7.5 5 7 4.5 7 3V1L11 5Z" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <span data-click="no">{{ $t('offer.download_pdf') }}</span>
                <tool-tip class="vue_tooltip hide" side="l" :text="$t('offer.download_pdf_tooltip')" />
            </a>
            <!-- ----------------------------------- -->
            <a :class="'button_with_without_text vue_show_tooltip' + (pdfLoading ? ' pdf-loading' : '')" v-if="data.offer.koncept == 0" :href="'/pdf/' +
                data.offer.uuid +
                '/' +
                (data.offer.mojafirma ? data.offer.mojafirma.slug : data.slug) +
                '/' +
                data.offer.id
                " @click="startPdfLoading" data-click="no">
                <span class="pdf-btn-icon" data-click="no">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"
                        data-click="no">
                        <path d="M4.5 5.5V8.5L5.5 7.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M4.5 8.5L3.5 7.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M11 5V7.5C11 10 10 11 7.5 11H4.5C2 11 1 10 1 7.5V4.5C1 2 2 1 4.5 1H7"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M11 5H9C7.5 5 7 4.5 7 3V1L11 5Z" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </span>
                <span class="pdf-btn-spinner" data-click="no"></span>
                <span data-click="no">{{ $t('offer.download_pdf') }}</span>
                <tool-tip class="vue_tooltip hide" side="l" text="Export do PDF" />
            </a>
        </div>
        <div class="right_side">
            <div class="first-row">
                <!-- UPRAVA PONUKY -->
                <div class="button_with_without_text vue_show_tooltip" @click="editOffer" data-click="no" id="v-step-4">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"
                        data-click="no">
                        <path d="M5.5 1H4.5C2 1 1 2 1 4.5V7.5C1 10 2 11 4.5 11H7.5C10 11 11 10 11 7.5V6.5"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path
                            d="M8.02 1.50999L4.08 5.44999C3.93 5.59999 3.78 5.89499 3.75 6.10999L3.535 7.61499C3.455 8.15999 3.84 8.53999 4.385 8.46499L5.89 8.24999C6.1 8.21999 6.395 8.06999 6.55 7.91999L10.49 3.97999C11.17 3.29999 11.49 2.50999 10.49 1.50999C9.49 0.509989 8.7 0.829989 8.02 1.50999Z"
                            stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M7.45499 2.07498C7.78999 3.26998 8.72499 4.20498 9.92499 4.54498" stroke-miterlimit="10"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <tool-tip class="vue_tooltip hide" side="l" :text="$t('offer.edit_offer_tooltip')" />
                </div>
                <!-- UPRAVA POLOŽIEK -->
                <div class="button_with_without_text vue_show_tooltip" @click="editEntry" data-click="no">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"
                        data-click="no">
                        <path
                            d="M6.50498 1.46003L9.45498 2.77003C10.305 3.14503 10.305 3.76503 9.45498 4.14003L6.50498 5.45003C6.16998 5.60003 5.61998 5.60003 5.28498 5.45003L2.33498 4.14003C1.48498 3.76503 1.48498 3.14503 2.33498 2.77003L5.28498 1.46003C5.61998 1.31003 6.16998 1.31003 6.50498 1.46003Z"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path
                            d="M1.5 5.5C1.5 5.92 1.815 6.405 2.2 6.575L5.595 8.085C5.855 8.2 6.15 8.2 6.405 8.085L9.8 6.575C10.185 6.405 10.5 5.92 10.5 5.5"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path
                            d="M1.5 8C1.5 8.465 1.775 8.885 2.2 9.075L5.595 10.585C5.855 10.7 6.15 10.7 6.405 10.585L9.8 9.075C10.225 8.885 10.5 8.465 10.5 8"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <tool-tip class="vue_tooltip hide" side="l" :text="$t('offer.manage_items_tooltip')" />
                </div>
                <!-- DUPLIKOVAŤ PONUKU -->
                <a class="button_with_without_text vue_show_tooltip" :href="'/admin/offer/' + data.offer.uuid + '/copy'"
                    data-click="no" id="v-step-5">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"
                        data-click="no">
                        <path d="M8.5 6.7V8.2C8.5 10.2 7.7 11 5.7 11H3.8C1.8 11 1 10.2 1 8.2V6.3C1 4.3 1.8 3.5 3.8 3.5H5.3"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M8.49996 6.7H6.89996C5.69996 6.7 5.29996 6.3 5.29996 5.1V3.5L8.49996 6.7Z"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M5.79996 1H7.79996" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M3.5 2.5C3.5 1.67 4.17 1 5 1H6.31" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M11 4V7.095C11 7.87 10.37 8.5 9.59503 8.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M11 4H9.5C8.375 4 8 3.625 8 2.5V1L11 4Z" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <tool-tip class="vue_tooltip hide" side="l" :text="$t('offer.duplicate_tooltip')" />
                </a>
                <!-- HISTÓRIA A POZNÁMKY -->
                <history-nodes :statusHistoryNodes="statusHistoryNodes" :uuid="data.offer.uuid" :notes="data.notes" :info="{
                    offerName: data.offer.nazov,
                    clientName: data.klient_nazov
                        ? data.klient_nazov[0]
                        : 'klient',
                }" @closeModal="statusHistoryNodes = $event" />
                <a id="history_node_modal_button" class="button_with_without_text vue_show_tooltip" data-click="no"
                    @click="statusHistoryNodes = true">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"
                        data-click="no">
                        <path d="M4 1V2.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M8 1V2.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                            d="M10.5 4.25V8.5C10.5 10 9.75 11 8 11H4C2.25 11 1.5 10 1.5 8.5V4.25C1.5 2.75 2.25 1.75 4 1.75H8C9.75 1.75 10.5 2.75 10.5 4.25Z"
                            stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M4 5.5H8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M4 8H6" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <tool-tip class="vue_tooltip hide" side="l" :text="$t('offer.history_tooltip')" />
                </a>
                <!-- SUPER FAKTURA -->
                <super-faktura :create_sf="create_sf()" :offer_id="data.offer.uuid" data-click="no" />
                <!-- ODOSIELANIE PONUKY -->
                <send-offer :user="user" :sendEmail="sendEmail" :url="'/' +
                    data.offer.uuid +
                    '/' +
                    (data.offer.mojafirma ? data.offer.mojafirma.slug : data.slug) +
                    '/' +
                    data.offer.id
                    " :offer_uuid="data.offer.uuid" :offer_email="data.offer_email" :klient_name="data.klient_nazov ? data.klient_nazov[0] : 'klient'
                        " :klient_email="data.klient_email ? data.klient_email[0] : ''
                        " />
            </div>
            <div class="second-row">
                <!-- VYMAZANIE PONUKY -->
                <div id="delete_offer" class="button_remove vue_show_tooltip" @click="deleteOffer" data-click="no">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"
                        data-click="no">
                        <path
                            d="M10.5 2.99001C8.835 2.82501 7.16 2.74001 5.49 2.74001C4.5 2.74001 3.51 2.79001 2.52 2.89001L1.5 2.99001"
                            stroke="#F93C34" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                            d="M4.25 2.485L4.36 1.83C4.44 1.355 4.5 1 5.345 1H6.655C7.5 1 7.565 1.375 7.64 1.835L7.75 2.485"
                            stroke="#F93C34" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                            d="M9.42507 4.56999L9.10007 9.60499C9.04507 10.39 9.00007 11 7.60507 11H4.39507C3.00007 11 2.95507 10.39 2.90007 9.60499L2.57507 4.56999"
                            stroke="#F93C34" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M5.16498 8.25H6.82998" stroke="#F93C34" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M4.75 6.25H7.25" stroke="#F93C34" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <tool-tip class="vue_tooltip hide" side="r" :text="$t('offer.delete_tooltip')" />
                </div>
                <!-- DE/AKTIVACIA PONUKY -->
                <div :class="(data.offer.active == 0 ? 'deactive' : 'active') +
                ' button_de_active vue_show_tooltip'
                " @click="de_activeOffer" data-click="no">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                    data-click="no">
                    <path
                        d="M13.79 12C13.79 12.99 12.99 13.79 12 13.79C11.01 13.79 10.21 12.99 10.21 12C10.21 11.01 11.01 10.21 12 10.21C12.99 10.21 13.79 11.01 13.79 12Z"
                        stroke-linecap="round" stroke-linejoin="round" data-click="no" />
                    <path
                        d="M12 16.135C13.765 16.135 15.41 15.095 16.555 13.295C17.005 12.59 17.005 11.405 16.555 10.7C15.41 8.90002 13.765 7.86002 12 7.86002C10.235 7.86002 8.59004 8.90002 7.44504 10.7C6.99504 11.405 6.99504 12.59 7.44504 13.295C8.59004 15.095 10.235 16.135 12 16.135Z"
                        stroke-linecap="round" stroke-linejoin="round" data-click="no" />
                </svg>
                <tool-tip class="vue_tooltip hide" side="r" :text="data.offer.active == 0
                        ? $t('offer.deactivate')
                        : $t('offer.activate')
                    " />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import swal from 'sweetalert2/dist/sweetalert2.all.min.js'
import ToolTip from "../../vue_components/ToolTip.vue";
import SuperFaktura from "./SuperFaktura.vue";
import SendOffer from "./SendOffer.vue";
import HistoryNodes from "../../history/HistoryNodes.vue";
export default {
    components: { ToolTip, SuperFaktura, SendOffer, HistoryNodes },
    props: ["data", "user", "sendEmail"],
    data() {
        return {
            statusHistoryNodes: false,
            pdfLoading: false,
        };
    },
    methods: {
        startPdfLoading() {
            this.pdfLoading = true;
            const cleanup = () => {
                this.pdfLoading = false;
                window.removeEventListener('blur', cleanup);
            };
            window.addEventListener('blur', cleanup);
            setTimeout(cleanup, 30000);
        },
        changeSendStatus() {
            this.$emit("changeSendStatus", this.data.offer.uuid);
        },
        copyUrlOffer() {
            var href =
                window.location.origin + "/" +
                this.data.offer.uuid +
                "/" +
                (this.data.offer.mojafirma ? this.data.offer.mojafirma.slug.toString() : this.data.slug.toString()) +
                "/" +
                this.data.offer.id;
            var $temp = $("<input>");
            $("body").append($temp);
            $temp.val(href).select();
            document.execCommand("copy");
            $temp.remove();
            this.$toast.success(this.$t('offer.url_copied'), {
                timeout: 2038,
            });
        },
        de_activeOffer() {
            this.$emit("de_activeOffer", this.data.offer.uuid);
        },
        editOffer() {
            sessionStorage.removeItem("edit_polozka");
            window.location.href =
                "/admin/offers/" + this.data.offer.uuid + "/edit";
        },
        editEntry() {
            localStorage.setItem("edit_polozka", "success");
            window.location.href =
                "/admin/offers/" + this.data.offer.uuid + "/edit";
        },
        deleteOffer() {
            swal.fire({
                    title: this.$t('offer.delete_confirm_title'),
                    text: this.$t('offer.delete_confirm_text'),
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    cancelButtonText: "Nie",
                    confirmButtonText: this.$t('offer.delete_confirm_btn'),
                })
                .then((result) => {
                    if (result.value) {
                        this.$emit("deleteOffer", this.data.offer.id);
                    }
                });
        },
        create_sf() {
            if (this.data.user.sf_key) {
                if (this.data.user.sf_email) {
                    return true;
                }
            }
            return false;
        },
    },
    mounted() {
        $(".vue_show_tooltip").hover(
            function () {
                $(this).find(".vue_tooltip").removeClass("hide");
                $(this).find(".vue_tooltip").addClass("show");
            },
            function () {
                $(this).find(".vue_tooltip").removeClass("show");
                $(this).find(".vue_tooltip").addClass("hide");
            }
        );
    },
};
</script>

<style lang="scss" scoped>
.vue_tooltip .hide {
    display: none;
}

.vue_tooltip .show {
    display: block;
}

.vue_show_tooltip {
    position: relative;
}

.bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media (max-width: 1200px) {
        flex-direction: column;
    }

    .left_side {
        display: flex;
        align-items: center;
        padding: 14px 10px 0 19px;
        @media (max-width: 600px) {
            flex-direction: column;
            gap: 15px;
        }
    }

    .button_with_without_text {
        cursor: pointer;
        width: auto;
        padding: 8px 8px;
        margin-right: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 24px;
        background: #f3f4f6;
        text-decoration: none;
        color: transparent;

        &.disabled {
            background: #f3f4f681;

            span {
                color: #9ca3af75;
            }

            &:hover {
                background: #f3f4f681;
                cursor: no-drop;
            }

            svg {
                path {
                    stroke: #9ca3af75;
                }
            }
        }

        span {
            font-family: "Montserrat";
            font-style: normal;
            font-weight: 600;
            font-size: 10px;
            line-height: 12px;
            letter-spacing: 0.12em;
            text-transform: uppercase;
            margin-left: 7px;
            color: #9ca3af;
        }

        &:hover {
            transition: all 0.3s;
            background: #e2e2e2;
        }

        &.clicked {
            background: #ecfdf5;

            span {
                color: #34d399;
            }

            svg {
                path {
                    stroke: #34d399;
                }
            }

            &:hover {
                transition: all 0.3s;
                background: #cfffe8;
            }
        }

        svg {
            path {
                stroke: #9ca3af;
            }
        }

        .pdf-btn-spinner {
            display: none;
            width: 10px;
            height: 10px;
            border: 1.5px solid #9ca3af;
            border-top-color: transparent;
            border-radius: 50%;
            animation: pdf-spin 0.7s linear infinite;
            flex-shrink: 0;
        }

        &.pdf-loading {
            opacity: 0.6;
            pointer-events: none;

            .pdf-btn-icon {
                display: none;
            }

            .pdf-btn-spinner {
                display: inline-block;
            }
        }
    }

    @keyframes pdf-spin {
        to {
            transform: rotate(360deg);
        }
    }

    .right_side {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 14px 24px 0 19px;
        gap: 118px;
        @media (max-width: 600px) {
            gap: 20px;
        }
        .first-row, .second-row {
            display: flex;
            align-items: center;
        }
        .button_remove {
            width: 28px;
            height: 28px;
            background: #fef2f2;
            border-radius: 28px;
            margin-right: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            &:hover {
                transition: all 0.3s;
                background: #ffdada;
            }
        }

        .button_de_active {
            width: 28px;
            height: 28px;
            border-radius: 28px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            &.active {
                background: #ecfdf5;

                &:hover {
                    transition: all 0.3s;
                    background: #cfffe8;
                }

                svg {
                    path {
                        stroke: #34d399;
                    }
                }
            }

            &.deactive {
                background: #fef2f2;

                &:hover {
                    transition: all 0.3s;
                    background: #ffdada;
                }

                svg {
                    path {
                        stroke: #f93c34;
                    }
                }
            }
        }
    }
}
</style>
